import { UnitDescription } from 'convert-units';
import { existsSync, readFileSync } from 'fs';
import { isNil, omitBy } from 'lodash-es';
import { join } from 'path';

import convert from '../utils/convert-utils';


function titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
}

interface Measurement {
    type: string;
    readableType: string;
}

interface UnitMeasure extends Measurement {
    unit: string;
}

export function generateRoutes(forRoot: boolean) {
    const routes = [];
    const measureMap = {};
    const measures: Measurement[] = convert().measures().map(_measure => {
        const measure = _measure; // [ 'length', 'mass', 'volume' ]
        measureMap[measure] = [];
        return {
            type: measure,
            readableType: titleCase(measure.replace(/([A-Z])/g, " $1")),
        }
    });

    measures.forEach(measure => {
        const unitMeasures = convert().possibilities(measure.type as any).map(possibility => {
            return {
                type: measure.type,
                readableType: measure.readableType,
                unit: possibility,
            };
        });
        createRoutesForMeasure(unitMeasures).forEach(route => {
            try {
                measureMap[measure.type].push(route);
            } catch (e) {
                console.log('HPY =============== ' + measure.type);
                console.dir(measureMap, { depth: null, colors: true });
                throw e;
            }
            routes.push(route);
        })
    });
    const routesToProcess = routes; 
    // const routesToProcess =  range(0, 10).map((i) => routes[i]); // 
    // const routesToProcess = routes.filter(i => i.id === 'gallons-per-minute-to-cubic-feet-per-second');
    // console.log("Routes ========================= []");
    // console.log(routesToProcess);
    const routesList = forRoot ? [{
        id: 'home',
        url: "/",
        title: "Unit Converter: Free Online Unit Conversion Tool | XConvert",
        measureMap,
    }] : routesToProcess;
    return [
        ...routesList,
    ];
};

function createRoutesForMeasure(unitMeasures: UnitMeasure[]) {
    const routes = [];
    unitMeasures.forEach(a => {
        unitMeasures.forEach(b => {
            if (a.unit !== b.unit) {
                const aDescription = convert().describe(a.unit as any);
                const bDescription = convert().describe(b.unit as any);
                const pathBasename = `${aDescription.plural.toLowerCase()}-to-${bDescription.plural.toLowerCase()}`.replace(/ /ig, '-').replace(/\//ig, 'per');
                const routeData = {
                    id: `${aDescription.plural.toLowerCase()}-to-${bDescription.plural.toLowerCase()}`.replace(/ /ig, '-').replace(/\//ig, 'per'),
                    url: `/${pathBasename}`,
                    title: `${aDescription.plural} To ${bDescription.plural} | Convert ${aDescription.abbr} To ${bDescription.abbr} Online - XConvert`,
                    from: {
                        ...a
                    },
                    to: {
                        ...b
                    },
                    pageContent: applyValuesToPageContent(
                        getPageContentForRoutePath(pathBasename),
                        aDescription,
                        bDescription,
                    ),
                    pageSummary: getPageSummaryForRoutePath(pathBasename),
                    // applyValuesToPageSummary(getPageSummaryForRoutePath(pathBasename), aDescription),
                    fromUnitContent: getUnitContentForUnit(aDescription.plural.toLowerCase()),
                    toUnitContent: getUnitContentForUnit(bDescription.plural.toLowerCase()),
                };
                routes.push(omitBy(routeData, isNil));
            }
        });
    });
    return routes;
}

function applyValuesToPageContent(pageContentHtml: string, fromDescription: UnitDescription, toDescription: UnitDescription) {
    console.log(`Called applyValuesToPageContent: ${pageContentHtml}`);

    if(!pageContentHtml){
        return pageContentHtml;
    }
    console.log(fromDescription, toDescription)
    var updatedContentHtml = pageContentHtml.replaceAll('{{fromUnitReadablePlural}}', fromDescription.plural.toLowerCase());
    updatedContentHtml = updatedContentHtml.replaceAll('{{toUnitReadablePlural}}', toDescription.plural.toLowerCase());
    return updatedContentHtml;
}
// function applyValuesToPageSummary(pageSummaryHtml: string, fromDescription: UnitDescription) {
//     if(!pageSummaryHtml){
//         return pageSummaryHtml;
//     }
//     const updatedSummaryHtml = pageSummaryHtml.replaceAll('{{fromUnitReadableNameLongSingularFormat}}', fromDescription.plural.toLowerCase());
//     return updatedSummaryHtml;
// }

function getPageContentForRoutePath(path: string) {
    const projectPath = '/home/user/sites/ps2pdf/unit-converter/ssr';
    const buildDir = join(projectPath, 'build');
    const pageContentBuildDir = join(buildDir, 'page-content');

    if (!existsSync(pageContentBuildDir)) {
        throw new Error(`Page content build path does not exists. Path: ${pageContentBuildDir}`);
    }

    const contentPath = join(pageContentBuildDir, `${path}.html`);
    if (existsSync(contentPath)) {
        // console.log(`Getting page for getPageContentForRoutePath: ${path}`);
        return readFileSync(contentPath, { encoding: 'utf8' })
    } else {
        // console.log(`No page for getPageContentForRoutePath: ${path}`);
    }
}

function getPageSummaryForRoutePath(path: string) {
    const projectPath = '/home/user/sites/ps2pdf/unit-converter/ssr';
    const buildDir = join(projectPath, 'build');
    const pageSummaryBuildDir = join(buildDir, 'page-summary');

    if (!existsSync(pageSummaryBuildDir)) {
        throw new Error(`Page summary build path does not exists. Path: ${pageSummaryBuildDir}`);
    }

    const summaryPath = join(pageSummaryBuildDir, `${path}.html`);
    if (existsSync(summaryPath)) {
        // console.log(`Getting page for getPageSummaryForRoutePath: ${path}`);
        return readFileSync(summaryPath, { encoding: 'utf8' })
    } else {
        // console.log(`No page for getPageSummaryForRoutePath: ${path}`);
    }
}

function getUnitContentForUnit(pluralUnitName: string) {
    pluralUnitName = pluralUnitName.replace(/ /ig, '-').replace(/\//ig, 'per');

    const projectPath = '/home/user/sites/ps2pdf/unit-converter/ssr';
    const buildDir = join(projectPath, 'build');
    const unitContentBuildDir = join(buildDir, 'unit-content');

    if (!existsSync(unitContentBuildDir)) {
        throw new Error(`Page content build path does not exists. Path: ${unitContentBuildDir}`);
    }

    const contentPath = join(unitContentBuildDir, `${pluralUnitName}.html`);
    if (existsSync(contentPath)) {
        // console.log(`Getting page for getUnitContentForUnit: ${pluralUnitName}`);
        return readFileSync(contentPath, { encoding: 'utf8' })
    } else {
        // console.log(`No page for getUnitContentForUnit: ${pluralUnitName}`);
    }
}